import { useAuthState } from 'react-firebase-hooks/auth'
import { auth } from '@/lib/firebase'

export function useAuth() {
  const [user, loading] = useAuthState(auth)
  return { user: user ?? null, loading }
}
